import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import createStore from '../../../../plugins/utils/createStore';
import { PeopleIcon } from '../../../Icons';
import ColumnTypes from '../../types/ColumnTypes';
import Field from './Field';
export default function UsersPlugin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$fetchUsers = _ref.fetchUsers,
      fetchUsers = _ref$fetchUsers === void 0 ? function (query, maxItemsOnEmptyQuery) {
    return [];
  } : _ref$fetchUsers;

  var store = createStore();
  return [{
    queries: {
      getFieldUsers: function getFieldUsers(database, recordKey, columnKey) {
        var _database$getFieldDat = database.getFieldData(recordKey, columnKey),
            users = _database$getFieldDat.users;

        return users || [];
      },
      getUsersFromQuery: function getUsersFromQuery(database, recordKey, columnKey) {
        var query,
            maxItemsOnEmptyQuery,
            currentUsers,
            users,
            _args = arguments;
        return _regeneratorRuntime.async(function getUsersFromQuery$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = _args.length > 3 && _args[3] !== undefined ? _args[3] : '';
                maxItemsOnEmptyQuery = _args.length > 4 ? _args[4] : undefined;
                currentUsers = database.getFieldUsers(recordKey, columnKey);
                _context.next = 5;
                return _regeneratorRuntime.awrap(fetchUsers(query.replace(/^@/, ''), //Users might use the @ just like in the app, just take it out
                maxItemsOnEmptyQuery));

              case 5:
                users = _context.sent;
                return _context.abrupt("return", users.filter(function (user) {
                  return !currentUsers.find(function (_ref2) {
                    var id = _ref2.id;
                    return user.id === id;
                  });
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        });
      }
    },
    commands: {
      addUserToField: function addUserToField(database, recordKey, columnKey, _ref3) {
        var id = _ref3.id,
            username = _ref3.username;
        return database.updateFieldData(recordKey, columnKey, function (_ref4) {
          var _ref4$users = _ref4.users,
              users = _ref4$users === void 0 ? [] : _ref4$users,
              data = _objectWithoutProperties(_ref4, ["users"]);

          return _objectSpread({}, data, {
            users: [].concat(_toConsumableArray(users), [{
              id: id,
              username: username
            }])
          });
        });
      },
      removeUserFromField: function removeUserFromField(database, recordKey, columnKey, user) {
        return database.updateFieldData(recordKey, columnKey, function (_ref5) {
          var _ref5$users = _ref5.users,
              users = _ref5$users === void 0 ? [] : _ref5$users,
              data = _objectWithoutProperties(_ref5, ["users"]);

          return _objectSpread({}, data, {
            users: users.filter(function (_ref6) {
              var id = _ref6.id;
              return id !== user.id;
            })
          });
        });
      }
    },
    getWidth: function getWidth(columnType, database, next) {
      if (ColumnTypes.USERS === columnType) {
        return 40;
      }

      return next();
    },
    renderColumnIcon: function renderColumnIcon(columnType, database, next) {
      if (ColumnTypes.USERS === columnType) {
        return React.createElement(PeopleIcon, null);
      }

      return next();
    },
    renderColumnType: function renderColumnType(columnType, database, next) {
      if (ColumnTypes.USERS === columnType) {
        return 'Users';
      }

      return next();
    },
    canEdit: function canEdit(columnType, database, next) {
      if (ColumnTypes.USERS === columnType) {
        return true;
      }

      return next();
    },
    onStartTyping: function onStartTyping(event, database, next) {
      var _database$getActive = database.getActive(),
          column = _database$getActive.column,
          record = _database$getActive.record;

      if (ColumnTypes.USERS !== column.type) {
        return next();
      }

      var fieldKey = database.getFieldKey(record.key, column.key);
      store.updateItem(fieldKey, {
        value: event.key.length === 1 ? event.key : ''
      });
      next();
    },
    renderField: function renderField(props, database, next) {
      if (ColumnTypes.USERS === props.column.type) {
        return React.createElement(Field, Object.assign({
          database: database,
          store: store
        }, props));
      }

      return next();
    },
    serializeField: function serializeField(_ref7, database, next) {
      var column = _ref7.column,
          record = _ref7.record,
          field = _ref7.field;
      if (ColumnTypes.USERS !== column.type) return next();
      return field.data.users.map(function (user) {
        return "@".concat(user.username);
      }).join(', ');
    }
  }];
}